import { NNBSP } from './char';
export var THOUSAND_DELIMITER = NNBSP;
export var FRACTIONAL_DELIMITER = ',';